<template>
    <div class="d-flex flex-column mh-100vh">
        <router-view/>
    </div>
</template>
<script>
import Cookies from 'js-cookie';

export default {
    created() {
        let locale = Cookies.get('locale');
        if (!locale) {
            locale = process.env.VUE_APP_LOCALE;
        }
        if (!locale) {
            locale = 'en';
        }
        this.$store.dispatch('SET_LOCALE', locale);
    },
    metaInfo() {
        return {
            title: `${this.$t('Cheap Car Rental')} | Autorent OÜ`,
            meta: [
                { name: 'Description', content: '1Autorent - Autorent OÜ - pakume kvaliteetset ning soodsa hinnaga autorenditeenust Tallinnas, pakume väikebusside ja sõiduautode rentimist!' },
                { property: 'Keywords', content: 'auto, väikebusside, sõiduautode, rentimine, autorent oü, soodsam, hinnad, soodne, 1autorent' },
                { property: 'contactName', content: '1autorent' },
                { property: 'contactPhoneNumber', content: '+372 53 555 999' },
                { property: 'contactNetworkAddress', content: 'info [t] 1autorent.ee' },
                { property: 'author', content: '1autorent | info [t] 1autorent.ee' },
                { property: 'copyright', content: 'Copyright (c) 2021 1autorent.ee' },
                { property: 'identifier-url', content: 'https://www.1autorent.ee/' },
                { property: 'linkage', content: 'https://www.1autorent.ee/' },
                { property: 'content-owner', content: '1autorent.ee' },
                { property: 'publisher', content: '1autorent.ee' },
                { property: 'contact', content: '1autorent.ee' },
                { property: 'distribution', content: 'global' },
                { property: 'coverage', content: 'global' },
                { property: 'rating', content: 'general' },
                { property: 'class', content: 'open' },
                { property: 'robots', content: 'index, follow' },
                { property: 'ROBOTS', content: 'ALL' },
                { property: 'expires', content: 'never' },
                { property: 'revisit-after', content: '3 days' }
            ]
        };
    }
};
</script>

<style lang="scss">
    .mh-100vh {
        min-height: 100vh;
    }
</style>
